module.exports = __webpack_public_path__ + "img/menu-gray-line.389239de.svg";